import ImgTag from "../Helpers/ImgTag";

const AirFooterBannerInfo = ({ imgPath }) => {
  return (
    <>
      <ImgTag
        loading="lazy"
        src={imgPath}
        quality={75}
        className="object-cover w-full h-auto mx-auto my-4 rounded-md max-[768px]:my-3"
        sizes="100vw"
        alt=""
      />
      {/* <p className="my-4 text-[#797979] font-bold text-lg max-[768px]:text-sm max-[768px]:my-3">
        This Gree air conditioner provides 11,600 BTU of efficient cooling,
        making it suitable for small and medium rooms. It is characterized by
        its energy efficiency and modern design that suits every decor.
      </p> */}
    </>
  );
};

export default AirFooterBannerInfo;
